import { API_ERROR_CODES } from '@/lib/constants/error-codes';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { getApiErrorBody } from '@/lib/utils/error.utils';

const MESSAGES = UI_STRINGS.INVESTOR_PROFILE.COLLEAGUE_ERRORS;

/** Request path prefix the Backend puts in `detail`, e.g. `colleagueContacts.2.sectorId already ...`. */
const ROW_PATH = /colleagueContacts\.(\d+)\./;

/** A rejected colleague row: which row, and the inline message to show on it. */
export interface ColleagueRowError {
  index: number;
  message: string;
}

/**
 * Pure: when a failed save was rejected for one colleague row, which row and
 * what to say. Undefined for any other failure (or when the Backend did not
 * name a row), so the caller falls back to the generic save-error toast.
 *
 * The Backend's error filter returns only `{ detail, code }`, so the row index
 * is read from the `colleagueContacts.<n>.` prefix of `detail`.
 */
export function getColleagueRowError(error: unknown): ColleagueRowError | undefined {
  const body = getApiErrorBody(error);
  if (!body) return undefined;
  const message =
    body.code === API_ERROR_CODES.COLLEAGUE_CONTACT_DUPLICATE_SECTOR
      ? MESSAGES.COLLEAGUE_CONTACT_DUPLICATE_SECTOR
      : body.code === API_ERROR_CODES.SECTOR_NOT_FOUND
        ? MESSAGES.SECTOR_NOT_FOUND
        : undefined;
  if (!message) return undefined;
  const match = ROW_PATH.exec(body.detail);
  if (!match) return undefined;
  return { index: Number(match[1]), message };
}
